import React from "react";
import Button from "@material-ui/core/Button";
import CircularProgress from "@material-ui/core/CircularProgress";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import { Formik, Form, Field } from "formik";
import { CheckboxWithLabel, TextField } from "formik-material-ui";
import * as Yup from "yup";
import PhoneInput from "components/custom/PhoneInput";
import { InputDetails } from "src/graphql/mutations/createEnquiry";
import { useRouter } from "next/router";
import useFormSubmit from "components/hooks/useFormSubmit";
import PhoneInputMinNumberMsg from "./PhoneInputMinNumberMsg";
// import Alert from "components/Alert";

const DownloadBrochureSchema = Yup.object().shape({
  firstName: Yup.string().required("First name field is required"),
  email: Yup.string()
    .email("Invalid email")
    .required("Email field is required"),
  contactNumber: Yup.string()
    .typeError("That doesn't look like a phone number")
    .required("Phone field is required")
    .min(8, PhoneInputMinNumberMsg),
});
type DownloadBrochureFormProps = {
  serviceId?: string;
};
const DownloadBrochureForm: React.FC<DownloadBrochureFormProps> = ({
  serviceId,
}) => {
  const router = useRouter();
  const { course } = router.query;
  const { handleFormSubmit } = useFormSubmit();

  const formFields: InputDetails = {
    form_type_constant_value_id: course ? "166" : "174",
    firstName: "",
    lastName: "",
    email: "",
    contactNumber: "",
    mode_of_contact_constant_value_id: "169",
    terms: false,
    enquiries_type: course
      ? "COURSE DOWNLOAD BROCHURE"
      : "DOWNLOAD CORPORATE BROCHURE",
    service_id: serviceId ? [serviceId] : [],
  };

  return (
    <>
      <Formik
        initialValues={formFields}
        validationSchema={DownloadBrochureSchema}
        onSubmit={handleFormSubmit}
      >
        {({ submitForm, isSubmitting, errors, touched }) => (
          <Form autoComplete="off">
            <Grid container spacing={2}>
              <Grid item xs={12} sm={12} md={12} lg={12}>
                <Field
                  component={TextField}
                  size="small"
                  name="firstName"
                  type="text"
                  label="First Name"
                  fullWidth
                  placeholder="Enter your first name"
                  error={Boolean(errors.firstName) && touched.firstName}
                />
              </Grid>
              <Grid item xs={12} sm={12} md={12} lg={12}>
                <Field
                  component={TextField}
                  size="small"
                  name="lastName"
                  type="text"
                  label="Last Name"
                  fullWidth
                  placeholder="Enter your last name"
                  error={Boolean(errors.lastName) && touched.lastName}
                />
              </Grid>
              <Grid item xs={12} sm={12} md={12} lg={12}>
                <Field
                  component={TextField}
                  size="small"
                  name="email"
                  type="email"
                  label="Email"
                  fullWidth
                  placeholder="Enter your email"
                  error={Boolean(errors.email) && touched.email}
                />
              </Grid>
              <Grid item xs={12} sm={12} md={12} lg={12}>
                <Field
                  component={PhoneInput}
                  name="contactNumber"
                  label="Phone"
                  fullWidth
                  placeholder="Enter your phone"
                  error={errors.contactNumber && touched.contactNumber}
                  countryCodeEditable={false}
                />
              </Grid>

              <Grid item xs={12} sm={12} md={12} lg={12}>
                <Field
                  component={CheckboxWithLabel}
                  name="terms"
                  type="checkbox"
                  Label={{
                    label: (
                      <Typography variant="caption">
                        I agree to be contacted in the most suitable manner (by
                        phone or email) in order to respond to my enquiry
                      </Typography>
                    ),
                  }}
                />
              </Grid>
              <Grid item xs={12}>
                <Button
                  variant="contained"
                  color="primary"
                  disabled={isSubmitting}
                  onClick={submitForm}
                  fullWidth
                  size="large"
                  style={{ marginTop: 16 }}
                  endIcon={isSubmitting && <CircularProgress size={27} />}
                >
                  {isSubmitting ? "Submitting " : "Submit"}
                </Button>
              </Grid>
            </Grid>
          </Form>
        )}
      </Formik>
    </>
  );
};

export default React.memo(DownloadBrochureForm);
